/* ==========================================================
GIVEAWAY ENTRIES BADGE – Quick-Buy-Modal: beim Öffnen UND bei Variantenwechsel
========================================================== */
(function () {
  function setEntries(badge, cents) {
    const tpl = badge.dataset.entriesLabel || '{entries} Lose';
    const block = badge.querySelector('.giveaway-total-entries-block');
    const text  = block && block.querySelector('.badge-entries-text');
    if (!text) return;
    text.textContent = tpl.replace('{entries}', Math.floor((cents || 0) / 100));
    if (block) block.style.display = '';
    badge.style.display = '';
  }

  function variantPriceFromJson(modal, variantId) {
    const scripts = modal.querySelectorAll('variant-picker script[type="application/json"]');
    for (const s of scripts) {
      try {
        const v = JSON.parse(s.textContent);
        if (v && String(v.id) === String(variantId) && typeof v.price === 'number') return v.price;
      } catch (e) {}
    }
    return null;
  }

  async function variantPriceFromProduct(modal, variantId) {
    const handle = (modal.getAttribute('handle') || '').split('?')[0];
    if (!handle || !variantId) return null;
    try {
      const res = await fetch('/products/' + handle + '.js');
      if (!res.ok) return null;
      const p = await res.json();
      const hit = p.variants.find(v => String(v.id) === String(variantId));
      return hit ? hit.price : null;
    } catch (e) { return null; }
  }

  async function update(modal) {
    const badge = modal.querySelector('.giveaway-badge-api');
    if (!badge) return;
    const idInput = modal.querySelector('input[name="id"]');
    const vid = idInput ? idInput.value : null;
    if (!vid) return;

    let price = variantPriceFromJson(modal, vid);
    if (price == null) price = await variantPriceFromProduct(modal, vid);
    if (price != null) setEntries(badge, price);
  }

  // Variantenwechsel
  document.addEventListener('change', function (e) {
    const input = e.target;
    if (!input || !input.name) return;
    const isVariant =
      input.name === 'id' ||
      /option\d+$/.test(input.name) ||
      input.closest('variant-picker, variant-selects');
    if (!isVariant) return;
    const modal = input.closest('quick-buy-modal');
    if (modal) setTimeout(() => update(modal), 60);
  });

  // Öffnen des Modals (das Attribut "open" erscheint)
  function watchModal(modal) {
    new MutationObserver(function () {
      if (modal.hasAttribute('open')) setTimeout(() => update(modal), 60);
    }).observe(modal, { attributes: true, attributeFilter: ['open'] });
    if (modal.hasAttribute('open')) setTimeout(() => update(modal), 60);
  }

  // Bestehende + später hinzukommende Modals beobachten
  document.querySelectorAll('quick-buy-modal').forEach(watchModal);
  new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      m.addedNodes.forEach(function (n) {
        if (n.nodeType !== 1) return;
        if (n.tagName === 'QUICK-BUY-MODAL') watchModal(n);
        else if (n.querySelectorAll) n.querySelectorAll('quick-buy-modal').forEach(watchModal);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
})();